<template>
  <div class="m-n3">
    <div class="row no-gutters">
      <div class="panel-list col-md-6 col-lg-4 d-flex flex-column">
        <div class="flex-none">
          <b-input-group size="md">
            <b-input-group-prepend>
              <span class="btn btn-secondary rounded-0" title="Search">
                <i v-if="true" class="fas fa-search"></i>
                <i v-if="false" class="fas fa-spinner fa-spin"></i>
              </span>
            </b-input-group-prepend>
            <b-form-input
              class="form-control rounded-0"
              placeholder="search by location name"
              name="search"
              type="search"
              :value="searchTerm"
              @input="setSearchTerm($event)"
              debounce="1000"
              autocomplete="off"
            ></b-form-input>
            <b-input-group-append v-if="searchTerm">
              <b-button @click="setSearchTerm('')" class="rounded-0"
                ><i class="fas fa-times-circle"></i
              ></b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="locations-list flex-grow-1 overflow-auto">
          <div class="btn-group d-flex w-100" role="group">
            <div
              class="btn btn-primary btn-sm rounded-0"
              @click="assignAllLocations"
            >
              Add All
            </div>
            <div
              class="btn btn-danger btn-sm rounded-0"
              @click="unassignAllLocations"
            >
              Remove All
            </div>
          </div>
          <div
            v-for="location in searchFilteredLocations"
            :key="location['@id']"
            :ref="'locationItem-' + location['@id']"
            class="border-bottom d-flex flex-row flex-none location"
          >
            <div
              class="flex-none d-flex px-3 location-checkbox-checked"
              v-if="location.assignment && location.assignment['@id']"
              @click="listClickUnassign(location)"
            >
              <i class="fas fa-check-square align-self-center"></i>
            </div>
            <div
              class="flex-none d-flex px-3 location-checkbox-unchecked"
              v-else
              @click="listClickAssign(location['@id'])"
            >
              <i class="far fa-square align-self-center"></i>
            </div>
            <div
              class="flex-grow-1 px-2 border-left"
              @click="itemClick(location)"
            >
              <div>{{ location.name }}</div>
              <div class="small">
                {{ `${location.lngLat.lat}, ${location.lngLat.lng}` }}
              </div>
            </div>
            <div
              class="location-chevron flex-none px-3 d-flex align-items-center"
              @click="itemClick(location)"
            >
              <i class="fa fa-chevron-right align-self-center"></i>
            </div>
          </div>

          <div v-if="isLoading" class="text-center p-3 text-muted">
            <i class="fa fa-spinner fa-spin"></i> Loading Locations and
            Assignments...
          </div>
          <div
            v-if="GEOCODE_SUGGESTIONS.length > 0"
            class="p-0 bg-white text-muted text-center border-bottom"
          >
            Other places <i class="fa fa-globe align-self-center ml-2"></i>
          </div>
          <div
            v-for="suggestion in GEOCODE_SUGGESTIONS"
            :key="suggestion.magicKey"
            class="border-bottom d-flex flex-row flex-none suggestion"
            @click="handleSelectGeocode(suggestion)"
          >
            <div class="flex-grow-1 p-2">
              <div>{{ suggestion.text }}</div>
            </div>
            <div class="flex-none d-flex pr-2">
              <i class="fa fa-globe align-self-center"></i>
            </div>
            <div
              class="assignment-chevron flex-none pl-1 pr-1 d-flex align-items-center"
            >
              <i class="fa fa-chevron-right align-self-center"></i>
            </div>
          </div>
        </div>
        <div v-if="message" :class="`p-3 flex-none ${messageType}`">
          {{ message }}
        </div>
        <div class="flex-none d-block">
          <div
            class="btn btn-primary btn-block rounded-0"
            @click="clickNew"
            v-show="!isNewLocation"
          >
            <i class="fa fa-plus mr-1"></i> New Location
          </div>
        </div>
      </div>
      <div class="panel-map col-md-6 col-lg-8 position-relative border">
        <LMap
          class="location-map"
          :zoom="map.zoom"
          :center="map.center"
          @update:center="centerUpdate"
          @click="mapClick"
          ref="leaflet"
          :options="map.options"
          @ready="addBasemapLayer(BASEMAP_ACTIVE)"
        >
          <LLayerGroup>
            <LMarker
              :lat-lng="this.lngLat"
              v-if="!locationId && this.lngLat.lat && this.lngLat.lng"
              :draggable="true"
              @moveend="dragendNew"
            >
              <MarkerPin :class="{ primary: true }"
                ><i class="fa fa-plus"></i
              ></MarkerPin>
              <LTooltip>
                <div>New location</div>
                <div v-if="this.name">{{ this.name }}</div>
                <div v-else class="font-weight-bold text-danger">
                  Needs a name
                </div>
                <div>Drag to move</div>
              </LTooltip>
            </LMarker>
            <LMarker
              v-for="location in closestLocations"
              :key="location['id']"
              :lat-lng.sync="location.lngLat"
              @click="markClickUnassign(location)"
              :draggable="false"
              v-if="
                location.assignment &&
                location.assignment['@id'] &&
                location.lngLat.lat &&
                location.lngLat.lng
              "
            >
              <MarkerPin :class="{ active: true }"
                ><i class="fas fa-square-check"></i
              ></MarkerPin>
              <LTooltip
                ><div>{{ location.name }}</div>
                <div>Click to see unassign</div></LTooltip
              >
            </LMarker>
            <LMarker
              v-for="location in closestLocations"
              :key="location['id']"
              :lat-lng.sync="location.lngLat"
              @click="markClickAssign(location)"
              :draggable="false"
              v-if="
                !location.assignment &&
                location.lngLat.lat &&
                location.lngLat.lng
              "
            >
              <MarkerPin><i class="far fa-square"></i></MarkerPin>
              <LTooltip
                ><div>{{ location.name }}</div>
                <div>Click to see assign</div></LTooltip
              >
            </LMarker>
            <LMarker :lat-lng="home" v-if="home && home.lat && home.lng">
              <MarkerPin><i class="fa fa-home"></i></MarkerPin>
              <LTooltip content="Project Home" />
            </LMarker>
            <LRectangle
              v-if="searchArea.area && searchArea.area.bounds"
              :bounds="searchArea.area.bounds"
              :l-style="searchArea.style"
            >
            </LRectangle>

            <LCircle
              v-else-if="
                searchArea.area &&
                searchArea.area.lngLat &&
                searchArea.area.accuracy
              "
              :lat-lng="searchArea.area.lngLat"
              :radius="searchArea.area.accuracy"
              :l-style="searchArea.style"
            >
            </LCircle>
          </LLayerGroup>
          <LControlZoom position="bottomright"></LControlZoom>
        </LMap>
        <div
          class="position-absolute map-help text-center"
          v-if="!isMapClicked"
        >
          <div>To add or remove a location</div>
          <div>Click on the checkbox in the list</div>
          <div>
            If you need to find a location, use the map or click the right side
            of the list.
          </div>
        </div>
        <div
          class="position-absolute map-help text-center"
          v-else-if="isNewLocation && !lngLat.lat && !lngLat.lng"
        >
          <div>Click / tap on map</div>
          <div>to set the coordinates for this new location</div>
        </div>
        <GpsInput
          v-on:input="setMapView"
          ref="GpsInput"
          class="position-absolute map-search"
        />
      </div>
    </div>
    <div
      class="location-new px-3 py-2 border-top bg-light"
      v-show="isNewLocation"
    >
      <h4>Add New Location</h4>
      <div class="row">
        <div class="col-md-9">
          <div class="row">
            <b-form-group
              id="name-input-group"
              class="col-12 mb-1"
              label="New Location Name"
              label-for="name"
            >
              <b-form-input
                id="name"
                ref="name"
                v-model="name"
                name="name"
                placeholder="Please name this location..."
                v-validate="{
                  required: true,
                  min: 5,
                  max: 100,
                }"
                data-vv-delay="500"
                :class="{
                  'is-invalid': errors.has(`name`),
                }"
                aria-describedby="name-live-feedback"
              ></b-form-input>
              <b-form-invalid-feedback
                id="name-live-feedback"
                v-if="errors.has('name')"
              >
                {{ errors.first("name") }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              id="latitude-input-group"
              class="col-6 mb-1"
              label="Latitude"
              label-for="latitude"
            >
              <b-form-input
                id="latitude"
                v-model="lngLat.lat"
                type="number"
                :number="true"
                name="latitude"
                placeholder="±90.0000000"
                :step="0.0005"
                v-validate="{
                  required: true,
                  decimal: 7,
                  min_value: -90,
                  max_value: 90,
                }"
                debounce="1500"
                :class="{
                  'is-invalid': errors.has(`latitude`),
                }"
                aria-describedby="latitude-live-feedback"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="longitude-input-group"
              class="col-6 mb-1"
              label="Longitude"
              label-for="longitude"
            >
              <b-form-input
                id="longitude"
                v-model="lngLat.lng"
                type="number"
                :number="true"
                name="longitude"
                placeholder="±180.0000000"
                :step="0.0005"
                v-validate="{
                  required: true,
                  decimal: 7,
                  min_value: -180,
                  max_value: 180,
                }"
                debounce="1500"
                :class="{
                  'is-invalid': errors.has(`longitude`),
                }"
                aria-describedby="longitude-live-feedback"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="col-md-3 align-self-end mb-1">
          <b-button
            variant="tertiary"
            block
            @click="
              createLocationAndAssignClick({ name: name, lngLat: lngLat })
            "
          >
            <i class="fa fa-check fa-lg"></i>
            <div>Add location & assign</div>
          </b-button>
          <b-button
            variant="danger"
            block
            class="mt-1"
            @click="
              (isNewLocation = false),
                (name = null),
                (lngLat = { lng: null, lat: null })
            "
          >
            <i class="fa fa-times fa-lg"></i>
            <div>Cancel adding</div>
          </b-button>
        </div>
        <div
          class="col-md-12 text-danger mb-2"
          v-if="!name && !lngLat.lat && !lngLat.lng"
        >
          Please enter a location name, and zoom in to select a latitude and
          longitude by either clicking the map or typing it in.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";

import {
  LMap,
  LTileLayer,
  LLayerGroup,
  LMarker,
  LPopup,
  LTooltip,
  LRectangle,
  LCircle,
  LControlZoom,
} from "vue2-leaflet";

import MarkerCrosshairs from "../../common/map/MarkerCrosshairs.vue";
import MarkerPin from "../../common/map/MarkerPin.vue";
import GpsInput from "../../common/map/gpsInput.vue";

export default {
  name: "DatasheetAssignLocations",
  components: {
    LMap,
    LTileLayer,
    LLayerGroup,
    LMarker,
    LPopup,
    LTooltip,
    LRectangle,
    LCircle,
    LControlZoom,
    MarkerCrosshairs,
    MarkerPin,
    GpsInput,
  },
  props: {
    home: {
      type: Object,
      default: null,
    },
    datasheetId: {
      type: String,
      default: null,
    },
    projectId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      name: null,
      lngLat: { lng: null, lat: null },
      locationId: null,

      map: {
        zoom: 12,
        center: { lng: -90, lat: 40 },
        options: {
          zoomControl: false,
        },
        // Used to find the closest assignments before panning finishes, while still allowing panning
        closestCenter: { lng: -90, lat: 40 },
      },
      searchArea: {
        area: null,
        style: {
          color: "#000000",
          weight: 10,
          opacity: 0.8,
          fillOpacity: 0,
        },
        tooltipStyle: {
          permanent: true,
          direction: "top",
          offset: [0, 100],
        },
      },

      isMapClicked: false,
      isNewLocation: false,
    };
  },
  mounted() {
    this.fetchDatasheetAssignmentsAndProjectLocations({
      datasheetId: this.datasheetId,
      projectId: this.projectId,
    });
    if (this.home && this.home.lat && this.home.lng) {
      this.map.center = this.home;
      this.map.closestCenter = this.home;
    }
  },
  computed: {
    ...mapGetters({
      allLocations: "datasheet/assignLocations/allLocations",
      searchFilteredLocations:
        "datasheet/assignLocations/searchFilteredLocations",
      isLoading: "datasheet/assignLocations/isLoading",
      BASEMAP_ACTIVE: "map/BASEMAP_ACTIVE",
    }),
    ...mapState({
      message: (state) => state.datasheet.assignLocations.message,
      messageType: (state) => state.datasheet.assignLocations.messageType,
      searchTerm: (state) => state.datasheet.assignLocations.searchTerm,
      GEOCODE_SUGGESTIONS: (state) => state.map.GEOCODE_SUGGESTIONS,
    }),
    closestLocations() {
      // only show the assignments closest to the center of the map
      // for performance reasons
      if (!this.allLocations) return [];
      // Calculate distance for each location
      const center = this.map.closestCenter;
      return this.allLocations
        .map((loc) => ({
          ...loc,
          _distance: Math.sqrt(
            Math.pow(center.lat - loc.lngLat.lat, 2) +
              Math.pow(center.lng - loc.lngLat.lng, 2)
          ),
        }))
        .sort((a, b) => a._distance - b._distance)
        .slice(0, 100)
        .reverse();
    },
  },

  methods: {
    // Component methods
    ...mapActions({
      fetchDatasheetAssignmentsAndProjectLocations:
        "datasheet/assignLocations/fetchDatasheetAssignmentsAndProjectLocations",
      ASSIGNED_LOCATIONS_SEARCH: "datasheet/assignLocations/setSearchTerm",
      assignLocation: "datasheet/assignLocations/assignLocation",
      unassignLocation: "datasheet/assignLocations/unassignLocation",
      assignAllLocations: "datasheet/assignLocations/assignAllLocations",
      unassignAllLocations: "datasheet/assignLocations/unassignAllLocations",
      createLocationAndAssign:
        "datasheet/assignLocations/createLocationAndAssign",
      GEOCODE_SEARCH: "map/GEOCODE_SEARCH",
      GEOCODE_SELECT: "map/GEOCODE_SELECT",
    }),
    mapReady() {
      // madness to resolve issues with the map tiles not rendering
      // because the map is in a modal, and that messes with the z-index
      // and the map container not being visible when the map is created
      const invalidateSize = () => {
        if (this.$refs.leaflet && this.$refs.leaflet.mapObject) {
          this.$refs.leaflet.mapObject.invalidateSize();
          console.log("invalidateSize called");
          return true;
        }
        console.log("invalidateSize not called");
        return false;
      };
      this.$nextTick(() => {
        if (invalidateSize()) return;
      });
    },
    setSearchTerm(term) {
      this.ASSIGNED_LOCATIONS_SEARCH(term);
      this.GEOCODE_SEARCH(term);
    },
    async handleSelectGeocode(suggestion) {
      try {
        const topCandidate = await this.GEOCODE_SELECT(suggestion);
        if (topCandidate) {
          this.setMapView(topCandidate);
        }
      } catch (error) {
        // vuex message contains the error
      }
    },
    centerUpdate(center) {
      this.map.center = center;
      this.map.closestCenter = center;
    },
    setMessage(message) {
      // replace with the store
      this.message = message;
    },
    clickNew() {
      console.log("clickNew");
      this.isMapClicked = true;
      this.isNewLocation = true;
      if (this.locationId) {
        this.locationId = null;
        this.assignmentId = null;
        this.name = null;
        this.lngLat = { lng: null, lat: null };
      }
      if (this.searchText) {
        this.name = this.searchText;
        this.searchText = null;
      }
      this.$nextTick(() => {
        let focusRef = this.$refs.name;
        focusRef.$refs.input.focus();
      });
    },
    dragendNew(e) {
      this.lngLat = {
        lng: e.sourceTarget._latlng.lng.toFixed(7),
        lat: e.sourceTarget._latlng.lat.toFixed(7),
      };
    },
    setMessage(message) {
      // replace with the store
      this.message = message;
    },
    mapClick(e) {
      this.setSearchTerm("");
      this.isMapClicked = true;
      if (this.isNewLocation) {
        console.log(e.latlng);
        this.lngLat = {
          lng: e.latlng.lng.toFixed(7),
          lat: e.latlng.lat.toFixed(7),
        };
        this.$nextTick(() => {
          let focusRef = this.$refs.name;
          focusRef.$refs.input.focus();
        });
      }
    },
    listClickAssign(locationId) {
      this.isMapClicked = true;
      this.assignLocation(locationId);
    },
    listClickUnassign(location) {
      this.isMapClicked = true;
      this.unassignLocation(location);
    },
    markClickAssign(location) {
      this.isMapClicked = true;
      this.setSearchTerm("");
      this.assignLocation(location["@id"]);
      this.$nextTick(() => {
        const refName = "locationItem-" + location["@id"];
        const el = this.$refs[refName];
        // $refs for v-for is an array, so use [0]
        if (el && el[0]) {
          el[0].scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    },
    markClickUnassign(location) {
      this.isMapClicked = true;
      this.setSearchTerm("");
      this.unassignLocation(location);
      this.$nextTick(() => {
        const refName = "locationItem-" + location["@id"];
        const el = this.$refs[refName];
        // $refs for v-for is an array, so use [0]
        if (el && el[0]) {
          el[0].scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    },
    itemClick(location) {
      this.isMapClicked = true;
      this.setMapView({ lngLat: location.lngLat, zoom: 15 });
    },
    setMapView(searchArea) {
      console.log("setMapView", searchArea);
      this.searchArea.area = searchArea;
      if (searchArea && searchArea.bounds) {
        this.$refs.leaflet.mapObject.flyToBounds(searchArea.bounds);
      } else if (searchArea && searchArea.lngLat) {
        this.$refs.leaflet.mapObject.flyTo(searchArea.lngLat, searchArea.zoom);
      }
    },
    panToLocal(lngLat, number = 3) {
      console.log(
        "Fitting map bounds to include this lngLat, and the X closest assignments"
      );
      console.log(lngLat);
      if (!(this.$refs.leaflet && this.$refs.leaflet.mapObject)) {
        return;
      }
      this.map.closestCenter = lngLat;

      const closest = this.allLocations
        .map((loc) => ({
          ...loc,
          _distance: Math.sqrt(
            Math.pow(lngLat.lat - loc.lngLat.lat, 2) +
              Math.pow(lngLat.lng - loc.lngLat.lng, 2)
          ),
        }))
        .sort((a, b) => a._distance - b._distance)
        .slice(0, number);
      console.log(closest);
      const bounds = closest.map((loc) => [loc.lngLat.lat, loc.lngLat.lng]);
      if (bounds.length > 0) {
        this.$refs.leaflet.mapObject.flyToBounds(bounds);
      }
    },
    createLocationAndAssignClick() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          return;
        }
        this.createLocationAndAssign({
          name: this.name,
          lngLat: this.lngLat,
        })
          .then(() => {
            this.isNewLocation = false;
            this.name = null;
            this.lngLat = { lng: null, lat: null };
            this.$validator.reset();
            const newLocation =
              this.allLocations[Object.keys(this.allLocations).length - 1];
            this.panToLocal(newLocation.lngLat, 10);
            this.$nextTick(() => {
              const refName = "locationItem-" + newLocation["@id"];
              const el = this.$refs[refName];
              // $refs for v-for is an array, so use [0]
              if (el && el[0]) {
                el[0].scrollIntoView({ behavior: "smooth", block: "center" });
              }
            });
          })
          .catch(() => {
            // vuex message contains the error
          });
      });
    },
    addBasemapLayer(newLayer, oldLayer) {
      const map = this.$refs.leaflet && this.$refs.leaflet.mapObject;
      if (!map || !newLayer) return;
      if (oldLayer) {
        try {
          map.removeLayer(oldLayer);
        } catch (e) {}
      }
      newLayer.addTo(map);
      map.invalidateSize();
    },
  },
  watch: {
    BASEMAP_ACTIVE(newLayer, oldLayer) {
      this.addBasemapLayer(newLayer, oldLayer);
    },
  },
};
</script>
<style scoped>
.panel-map {
}
.panel-list {
  max-height: 50vh;
  min-height: 300px;
}
.location-map {
  width: 100%;
  height: 50vh;
  min-height: 300px;
}
.map-help {
  z-index: 999;
  top: 25%;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  border-radius: 10px;
}
.locations-list {
}
.location-chevron {
  background-color: rgba(255, 255, 255, 1);
}
.location,
.location-chevron {
  transition: background-color 0.2s;
  cursor: pointer;
}

.location:hover > .location-chevron {
  background-color: rgba(135, 152, 63, 0.35);
}
.location.active {
  background-color: rgba(135, 152, 63, 0.2);
}
.location-checkbox-checked {
  background-color: rgba(135, 152, 63, 0.2);
  cursor: pointer;
}
.location-checkbox-checked:hover {
  background-color: rgb(213, 213, 213);
}
.location-checkbox-unchecked {
  background-color: rgba(255, 255, 255, 0.1);
  cursor: pointer;
}
.location-checkbox-unchecked:hover {
  background-color: rgba(135, 152, 63, 0.35);
}
.map-search {
  top: 10px;
  left: 10px;
  right: 10px;
  z-index: 500;

  @media (min-width: 768px) {
    width: 50%;
  }
}
</style>
